/**
 * Client-side template search for the Reports page catalog. Filters the
 * template registry (frontend/src/templates/index.js) by name/description,
 * case-insensitive, and regroups the matches by category so the search
 * results keep the same category-grouped presentation as normal browsing.
 */

/** Templates whose name or description contains `query` (case-insensitive). */
export function filterTemplates(templates, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return [];
  return templates.filter(
    (t) => t.name.toLowerCase().includes(q) || (t.description || '').toLowerCase().includes(q)
  );
}

/** Regroup a flat template list into [{ category, items }], category order = first-seen. */
export function groupByCategory(templates) {
  const order = [];
  const byCategory = new Map();
  for (const t of templates) {
    if (!byCategory.has(t.category)) {
      byCategory.set(t.category, []);
      order.push(t.category);
    }
    byCategory.get(t.category).push(t);
  }
  return order.map((category) => ({ category, items: byCategory.get(category) }));
}
